import React from 'react';
import { SubHeaderContainer } from './styles';

const SubHeader = ({ children }) => {
  return (
    <SubHeaderContainer>
      {children}
    </SubHeaderContainer>
  )
}

export default SubHeader;
